import React from "react";
import { connect } from "react-redux";

// COMPONENTS
import ExportCaseStudiesDialog from "../CaseStudyListPage/ExportCaseStudiesDialog";
import DeleteForm from "./DeleteForm";
import Modal from "../Shared/Modal";
import ArticleForm from "./ArticleForm";
import ExportResearchDialog from "../ResearchListPage/ExportResearchDialog";
import ExportMarketingDialog from "../MarketingMaterialsListPage/ExportMarketingDialog";
import ExportCEDialog from "../ContEducationListPage/ExportCEDialog";
import ExportInformationDialog from "../InformationListPage/ExportInformationDialog";
import ExportOtherArticlesDialog from "../OtherArticlesListPage/ExportOtherArticlesDialog";
import ResetForm from "./ResetForm";

const OptionsDialog = ({
    open,
    handleClose,
    page,
    searchTerm,
    newestFilter,
    manufacturerFilter,
    selectedAction,
    type,
    pageArticleType,
    article: { selectedArticle },
}) => {

    const addOrEdit = ['add', 'edit']
    return (
        <Modal
            open={open}
            setOpen={() => handleClose()}
            component={addOrEdit.includes(selectedAction) ?
                <ArticleForm
                    handleClose={handleClose}
                    page={page}
                    searchTerm={searchTerm}
                    newestFilter={newestFilter}
                    manufacturerFilter={manufacturerFilter}
                    type={type}
                    pageArticleType={pageArticleType}
                />
                : selectedAction === 'delete' && selectedArticle ?
                <DeleteForm
                    handleClose={handleClose}
                    page={page}
                    searchTerm={searchTerm}
                    newestFilter={newestFilter}
                    manufacturerFilter={manufacturerFilter}
                    pageArticleType={pageArticleType}
                />
                : selectedAction === 'reset' && selectedArticle ? 
                <ResetForm
                    handleClose={handleClose}
                    page={page}
                    searchTerm={searchTerm}
                    newestFilter={newestFilter}
                    manufacturerFilter={manufacturerFilter}
                    pageArticleType={pageArticleType}
                
                
                />
                : selectedAction === 'export-case-studies' ? (
                    <ExportCaseStudiesDialog
                        handleClose={handleClose}
                        pageArticleType={pageArticleType}
                    />
                ) : selectedAction === 'export-research-articles' ? (
                    <ExportResearchDialog
                        handleClose={handleClose}
                        pageArticleType={pageArticleType}
                    />
                ) : selectedAction === 'export-marketing-materials' ? (
                    <ExportMarketingDialog
                        handleClose={handleClose}
                        pageArticleType={pageArticleType}
                    />
                ) : selectedAction === 'export-cont-education' ? (
                    <ExportCEDialog
                        handleClose={handleClose}
                        pageArticleType={pageArticleType}
                    />
                ) : selectedAction === 'export-info-articles' ? (
                    <ExportInformationDialog
                        handleClose={handleClose}
                        pageArticleType={pageArticleType}
                    />
                ) : selectedAction === 'export-other-articles' ? (
                    <ExportOtherArticlesDialog
                        handleClose={handleClose}
                        pageArticleType={pageArticleType}
                    />
                ) : null
            }
        />
           
    );
};

OptionsDialog.propTypes = {};

const mapStateToProps = (state) => ({
    article: state.article,
});

 export default connect(mapStateToProps, {})(OptionsDialog);